import React from 'react';
import { MoonshotBox } from './MoonshotBox';
import { MoonshotSteps } from 'app/common/data/campaigns';
import { MoonshotSubmitFunction } from './types';
import styles from './MoonshotPlanSelection.less';
import Icon, { IconName, IconColor } from 'app/common/components/controls/icon';
import { Noun, Verb, trackUe } from '@trello/analytics';

const bcPlanSelectionList = [
  {
    icon: IconName.Board,
    title: 'Unlimited',
    content: 'Team Boards',
  },
  {
    icon: IconName.PowerUp,
    title: 'Unlimited',
    content: 'integrations.',
  },
  {
    icon: IconName.ButlerBot,
    title: 'Advance',
    content: 'Automations',
  },
  {
    icon: IconName.Subscribe,
    title: 'Assign',
    content: 'Admin roles',
  },
  {
    icon: IconName.Heart,
    title: 'Support',
    content: 'Within 1 day',
  },
  {
    icon: IconName.Star,
    title: 'Additional features',
    content: 'Like custom fields, board templates, and more!',
  },
];

const freeTeamSelectionList = [
  {
    icon: IconName.Board,
    title: '',
    content: 'Up to 10 Team Boards',
  },
  {
    icon: IconName.PowerUp,
    title: '',
    content: '1 Integration per Board',
  },
  {
    icon: IconName.ButlerBot,
    title: '',
    content: 'Limited Automations',
  },
];

interface MoonshotPlanSelectionProps {
  onSubmit: MoonshotSubmitFunction;
}

export const MoonshotPlanSelection: React.FC<MoonshotPlanSelectionProps> = ({
  onSubmit,
}) => {
  const onContinueWithTracking = () => {
    onSubmit(MoonshotSteps.PAYMENT_FORM);
    trackUe({
      category: Noun.MOONSHOT,
      verb: Verb.SUBMITS,
      directObj: Noun.BUSINESS_CLASS_UPSELL,
    });
  };

  const onSkipWithTracking = () => {
    onSubmit(MoonshotSteps.SUCCESS);
    trackUe({
      category: Noun.MOONSHOT,
      verb: Verb.SKIPS,
      directObj: Noun.BUSINESS_CLASS_UPSELL,
    });
  };

  return (
    <MoonshotBox className={styles.upperBox}>
      <div className={styles.heading}>
        <h1>
          <Icon
            name={IconName.BusinessClass}
            color={IconColor.Dark}
            className={styles.headingIcon}
          />{' '}
          Take Your Team Further
        </h1>
        <h2>
          Trello Business Class is trusted by people at Fender, National
          Geographic, Disney and more.
        </h2>
      </div>

      <div className={styles.bodyWrapper}>
        <div className={styles.freePlan}>
          <h2>Free Team</h2>
          <ul className={styles.freeTeamSelectionList}>
            {freeTeamSelectionList.map(({ icon, content }, index) => (
              <li key={index} className={styles.featureItem}>
                <Icon name={icon} medium className={styles.featureIcon} />
                <span className={styles.featureContent}>{content}</span>
              </li>
            ))}
          </ul>
          <button className={styles.ctaLink} onClick={onSkipWithTracking}>
            Get Started
          </button>
        </div>

        <div className={styles.bcPlan}>
          <div className={styles.recommendedLabel}>Recommended</div>
          <h2>Business Class Team</h2>
          <ul className={styles.bcPlanSelectionList}>
            {bcPlanSelectionList.map(({ icon, title, content }, index) => (
              <li key={index} className={styles.featureItem}>
                <Icon name={icon} medium className={styles.featureIcon} />
                <span className={styles.featureTitle}>
                  {title} {''}
                  <span className={styles.featureContent}>{content}</span>
                </span>
              </li>
            ))}
          </ul>
          <p>Only $9.99/user per month when billed annually</p>
          <button
            data-test-id="planSelectionButton"
            className={styles.ctaButton}
            onClick={onContinueWithTracking}
          >
            Start with Business Class
          </button>
        </div>
      </div>
    </MoonshotBox>
  );
};
